export default class {
  init() {
    const $elements = $("section.image-comparison .slick-slider");

    if ($elements.length) {
      (async () => {
        await import("slick-carousel");
        const Cocoen = (await import("cocoen/src/js/cocoen")).default;

        document.querySelectorAll(".cocoen").forEach((el) => {
          // eslint-disable-next-line
          new Cocoen(el);
        });

        [...$elements].forEach((el) => {
          $(el)
            .on("init", () => {
              window.App.aos.refreshHard();
            })
            .slick({
              slidesToShow: 1,
              dots: true,
              arrows: true,
              swipe: false,
              appendDots: $(el).parents("section").find("[slick-dots]"),
              nextArrow: $(el).parents("section").find("[slick-next]"),
              prevArrow: $(el).parents("section").find("[slick-prev]"),
            });
        });
      })();
    }
  }
}
